import { Box } from "@mui/material";
import React from "react";
const margin = "30px"
const MarginBox = (props: any) => {
    return <div style={{marginLeft: `${margin}`, marginRight: `${margin}`, 
    // border: "1px solid yellow", 
    height: "100%" }}>{props.children}</div>
}

export default MarginBox;